<template>
  <div :class="{'activebuy' : focusebuy === true}" class="input">
    <span :class="{'focusebuy' : focusebuy === true , 'unfocusebuy' : focusebuy === false }" class="placeholder">
     {{placeholder}}
    </span>
    <div class="text-input">
      <input @focusin="focusebuy = true" @focusout="focusebuy = false" type="text" class="inp-text"/>
      <inline-svg :src="require('../../assets/coins/' + state.marketType + '.svg') "/>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-buy-input",
  props:['placeholder' ,'data'],
  data(){
    return{
      focusebuy:false,
    }
  }
}
</script>

<style lang="scss" scoped>
.focusebuy{
  font-size: 10px !important;
  color: rgba(17, 153, 250, 1) !important;
  position: absolute;
  top: 3px !important;
}

.activebuy{
  border: 1px solid #FFFFFF !important;
}

.unfocusebuy{
  color: rgba(115, 109, 109, 1) !important;
  font-size: 12px !important;
}

.input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #736D6D;
  box-sizing: border-box;
  border-radius: 4px;
  height: 36px;
  width: 100%;
  padding: 8px;
  position: relative;

  >span{
    transition: top 0.3s , font-size 0.3s;
  }

  &:hover {
    border: 1px solid rgba(251, 251, 253, 1) !important;
  }

  &:hover .placeholder {
    color: rgba(215, 200, 200, 1);
  }

  .placeholder {
    color: rgba(115, 109, 109, 1);
    font-size: 12px;
    position: absolute;
    top: 25%;
  }

  .text-input {
    display: flex;
    flex-direction: row;
    gap: 5px;
    left: 5px;
    position: absolute;

    .inp-text {
      font-size: 12px;
      font-weight: bold;
      color: #FFFFFF;
      text-align: left;
    }
  }

  .inp-text:hover .placeholder {
    color: #1199FA !important;
  }
}

</style>